import { createClient } from '@supabase/supabase-js';

// Browser-exposed env vars must be prefixed with REACT_APP_ in Create React App.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

// Single shared client. Edge Functions are invoked through this (the anon key
// is a valid JWT, so functions with verify_jwt=true accept it). All privileged
// data access happens inside the functions using the service-role key.
export const supabase = isSupabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : null;
